
import React, { Component, PropTypes } from 'react';
import { UserIsAuthenticated, UserIsVerified } from '../utils/auth';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { pushState } from 'redux-router';
import AccordionTable from '../components/applyForBuyFromWomen/AccordionTable';
import TableLayout from '../components/applyForBuyFromWomen/TableLayout';

class ApplyBuyFromWomenLP extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  render() {

    let browser = this.props.browser;

    let listingOptions = '';
    if (browser.greaterThan.desktop) {
      listingOptions = <TableLayout />
    } else {
      listingOptions = <AccordionTable />
    }

    return(
      <main>
        {/* BEGIN content-wrapper */}


          <div className="content-wrapper">

            <div className="buyFromWomen-bannerWrapper">
              <div className="buyFromWomen-bannerImage">
                <img className="buyFromWomen-desktop" src="/images/buy_from_women/banner/desktop/banner.jpg" />
                <img className="buyFromWomen-tablet" src="/images/buy_from_women/banner/tablet/banner.jpg" />
                <img className="buyFromWomen-mobile" src="/images/buy_from_women/banner/mobile/banner.jpg" />
              </div>

              <div className="buyFromWomen-bannerTagWrapperOuter bfwBannerTagWrapperOuter">
                <div className="buyFromWomen-bannerTagWrapper bfwBannerTagWrapper">
                  Increase visibility &bull; drive sales &bull; grow your business
                </div>

              </div>

              <div className="buyFromWomen-bfwLogoOverlay">
                <img src="/images/buy_from_women/buy_from_women_overlay2.png" />
              </div>

            </div>

          {/* BEGIN WRAPPER */}
          <div className="applyToListLP-wrapper">

            {/* BEGIN PAGE HEADER */}
            <div className="applyToListLP-header">
              <h2 className="phone">Join our BuyFromWomen<sup className="bfw-tm">&trade;</sup> 2018 initiative</h2>

              <h2 className="larger-phone">Join our BuyFromWomen<sup className="bfw-tm">&trade;</sup> 2018 initiative</h2>
            </div>
            {/* END PAGE HEADER */}

            {/* BEGIN MAIN CONTENT */}



            <div className="applyToListLP-bodyWrapper">

              {/* BEGIN SECTION */}
              <div className="applyToListLP-bodySection">

                <p>
                  WorldWideWomen, a rapidly-growing online resource center for women, is excited to announce a 2018 initiative supporting women-owned businesses. Our goal is to showcase and promote women-owned businesses like yours to help you build visibility, drive sales, and scale and grow your business. Please join our campaign and become a member of our global community by listing your business on the WorldWideWomen platform. We are offering two membership options as shown below:
                </p>

              </div>
              {/* END SECTION */}


              { listingOptions }


              {/* BEGIN SECTION */}
              <div className="applyToListLP-bodySection">
                <div className="applyToListLP-sectionHead">Our reach and demographics</div>
                <div className="applyToListLP-sectionList">
                  <ul className="bulleted">
                    <li className="bulleted">Monthly visitors: 5,000</li>
                    <li className="bulleted">WorldWideWomen members: 2,000+ from 91 countries</li>
                    <li className="bulleted">Newsletter (weekly) Database: 30,000; open rate: 20%</li>
                    <li className="bulleted">Facebook followers: 100,000</li>
                  </ul>
                </div>
              </div>
              {/* END SECTION */}

              {/* BEGIN CHART/MAP SECTION DESKTOP */}
              <div className="applyToListLP-chartMapSectionDesktop">
                <img src="images/apply_to_list_lp/map_desktop.jpg" />
              </div>
              {/* END CHART/MAP SECTION DESKTOP */}

              {/* BEGIN CHART/MAP SECTION MOBILE */}
              <div className="applyToListLP-chartMapSectionMobile">
                <img src="images/apply_to_list_lp/map.jpg" />
              </div>
              {/* END CHART/MAP SECTION MOBILE */}


              {/* BEGIN SECTION */}
              <div className="applyToListLP-bodySection">
                <p>
                  We are looking forward to welcoming you to our 100,000+ global community. For additional information and/or questions, please contact <a href="mailTo: imccomish@worldwidewomen.co">Isabel McComish</a>.
                </p>

              </div>
              {/* END SECTION */}

              {/* BEGIN BUTTON */}
              <div className="applyToListLP-button">
                <a className="button button-primary" href="/bfw-apply-to-list">Submit your application</a>
              </div>
              {/* END BUTTON */}

            </div>
            {/* END MAIN CONTENT */}

            {/* BEGIN SIDEBAR */}
            <div className="applyToListLP-sidebar">

              {/* BEGIN SECTION */}
              <div className="applyToListLP-sidebarSection">
                <div className="applyToListLP-image sidebarImg">
                  <img src="images/apply_to_list_lp/bfw_wendy.jpg" />
                </div>
                <div className="applyToListLP-copy applyBFWLP-copy">
                  <p>"I joined [WorldWideWomen] because I run an all-woman website development team. We were so thrilled to be featured on their newsletter, and almost immediately received a call from New York from an organization serving women who needed a fresh design for their website." &mdash; Wendy Louise Nog, MSTM, Owner of Future Bright</p>
                </div>
              </div>
              {/* END SECTION */}

              {/* BEGIN SECTION */}
              <div className="applyToListLP-sidebarSection">
                <div className="applyToListLP-image sidebarImg">
                  <img src="images/apply_to_list_lp/bfw_bethany.jpg" />
                </div>
                <div className="applyToListLP-copy applyBFWLP-copy">
                  <p>"I love that it's kind of a one stop shop. No matter what type of service or product you are looking for, it's more likely than not going to be available on the WorldWideWomen site." &mdash; Bethany Peak, Owner of Taupe Coat</p>
                </div>
              </div>
              {/* END SECTION */}

              {/* BEGIN SECTION */}
              <div className="applyToListLP-sidebarSection">
                <div className="applyToListLP-image sidebarImg">
                  <img src="images/apply_to_list_lp/bfw_rebecca.jpg" />
                </div>
                <div className="applyToListLP-copy applyBFWLP-copy">
                  <p>"I'm very careful about what I align my brand with, and I had no pause in aligning my brand with [WorldWideWomen]." &mdash; Rebecca Hall Gruyter, Owner of Your Purpose Driven Practice</p>
                </div>
              </div>
              {/* END SECTION */}






            </div>
            {/* END SIDEBAR */}

          </div>
          {/* END WRAPPER */}

        </div>
        {/* END content-wrapper */}
      </main>

    );
  }
}


function mapStateToProps(state) {
  return state;
};




export default connect(
  mapStateToProps,
  {
    pushState
 })(ApplyBuyFromWomenLP);



// WEBPACK FOOTER //
// ./src/containers/ApplyBuyFromWomenLP.jsx